export const APP_SUBSCRIBE_TO_NEWSLETTER_SUCCESS = "APP_SUBSCRIBE_TO_NEWSLETTER_SUCCESS";
export const AppSubscribeToNewsletterSetAccepted = (options) => {
	return {
		type: APP_SUBSCRIBE_TO_NEWSLETTER_SUCCESS,
		payload: {
			accepted: options.accepted,
		},
	};
};
